import {
    extractAndParseJsonFromBox,
    fileStatusChange,
    getOrgImageKeys, pollingFileTranslation,
    pollingRefreshFileInfo
} from "@/components/file_process_js/utils";
import store from "@/store";
import {commitBatchImgTranslateTask, commitFileTranslateTask} from "@/api/file_translation";
import {getFileUrl, getTranslationUrl} from "@/api/oss";
import {ElMessage} from "element-plus";

const translationSaveBucket = "test-translation"

function translationParseMDWarp() {

    console.log("translationParseMDWarp")

    async function translationParseMD(fileInfo) {
        console.log("translationTask", fileInfo)

        await translationTask(fileInfo)
        if (!fileInfo.translation_detail) {
            console.log("translationParseMDWarp translationDetail not expect", fileInfo)
            return
        }

        applyTranslationResult(fileInfo)
        await store.commit("addTranslationChangeSign")
        await store.dispatch("syncWindowState")
    }

    return translationParseMD
}


async function translationTask(fileInfo) {

    if (fileInfo.translation_detail) {
        return
    }


    if (!fileInfo.language.some(item => ["English", "Japanese", "Italian", "Korean", "Other"].includes(item))) {
        console.log("start translationTask  no English task", fileInfo, fileInfo.version, fileInfo.language)
        return
    }

    console.log("start translationTask 1", fileInfo);

    if (!fileInfo.file_image_keys.length) {
        // console.log("no fileInfo.file_image_keys.length", fileInfo);
        return
    }

    const orgImageKeys = getOrgImageKeys(fileInfo)
    // fileStatusChange(fileInfo, "file translationing")
    // console.log(" commitFileLLMAnalyseTask fileInfo", fileInfo, fileInfo["file_image_keys"])

    let targetKey = fileInfo.file_key


    if (["doc", "xls", "xlsx", "docx", "image"].includes(fileInfo.file_type)) {
        const task_resp = await commitBatchImgTranslateTask(
            targetKey,
            orgImageKeys,
            fileInfo.file_hash,
            fileInfo.project_id,
            translationSaveBucket
        )
        fileInfo.translation_task_id = task_resp['task_id']
    } else {
        const task_resp = await commitFileTranslateTask(
            targetKey,
            fileInfo.root_key,
            fileInfo.file_hash,
            fileInfo.project_id,
            translationSaveBucket
        )
        fileInfo.translation_task_id = task_resp['task_id']
    }

    if (!fileInfo.translation_task_id) {
        ElMessage.warning(`翻译任务提交失败，文件：${fileInfo.file_key}, 请检查文件或联系研发`)
        return
    }


    await pollingFileTranslation(fileInfo, breakFunction, callbackLabelParseWarp(fileInfo), 50, 3000);
}

function breakFunction(remoteInfo) {
    return remoteInfo.task_status && remoteInfo.task_status === "completed" || remoteInfo.task_status === "failed"
}


function callbackLabelParseWarp(fileInfo) {
    return (remoteInfo) => {
        if (remoteInfo.error_massage) {
            ElMessage.warning(`翻译失败，文件：${fileInfo.file_key}, 请检查文件或联系研发`)
            console.log(`翻译失败，文件：${fileInfo}; remoteInfo：${remoteInfo}`)
        }
        fileInfo.translation_detail = remoteInfo.result
        // console.log("translationTask callbackLabelParseWarp", remoteInfo.result)
    }
}

function applyTranslationResult(fileInfo) {

    // todo
    // if (["image"].includes(fileInfo.file_type)) {
    //     const translated_url = fileInfo.translation_detail.translated_url
    //
    //     if (!translated_url) {
    //         console.log("applyTranslationResult no translated_url", fileInfo)
    //         return
    //     }
    //     const translated_url_key = translated_url.replace(`${translationSaveBucket}/`, "")
    //     const resKey = getFileUrl(translationSaveBucket, translated_url_key)
    //     if (!fileInfo.translation_image_urls.includes(resKey)) {
    //         fileInfo.translation_image_urls.push(resKey)
    //     }
    // }
    if (["pdf", "doc", "xls", "xlsx", "docx", "image"].includes(fileInfo.file_type)) {
        const translated_urls = fileInfo.translation_detail.translated_pages_url
        if (!translated_urls || !translated_urls.length) {
            // console.log("applyTranslationResult no translated_url", fileInfo)
            return
        }
        translated_urls.forEach(translated_url => {
            const resUrl = getTranslationUrl(translated_url)
            if (!fileInfo.translation_image_urls.includes(resUrl)) {
                fileInfo.translation_image_urls.push(resUrl)
            }
        })
        console.log("applyTranslationResult", fileInfo)
    }
}


export function getTranslationMD(fileInfo) {
    console.log("getTranslationParseMD", fileInfo)
    return translationParseMDWarp();
}